import { Tooltip } from '@material-ui/core';
import { SubMenuWrapper } from '../EditDefaultsMenu.style';
import { MenuButtonItem } from 'components/MenuButton';
import Icon from 'components/base/Icon';
import { GRAPH_COLORS } from '../../../../../CustomReport/Widgets/consts/colors';
import {
  ColorBox,
  ColorPickerPalleteWithoutMenu
} from 'components/base/ColorPickerPallete';
import { hexToColorName } from 'common/constants/_colors';

const ColorPickerItem = ({ graphColor, onColorChange }) => {
  return (
    <Tooltip
      title={
        <ColorPickerPalleteWithoutMenu
          chunks={1}
          colors={GRAPH_COLORS}
          selectedColor={graphColor}
          onChange={color => onColorChange(hexToColorName(color))}
        />
      }
      interactive
      placement='right'
    >
      <SubMenuWrapper>
        <MenuButtonItem
          key='Change color'
          text='Change color'
          icon={<ColorBox size='0.9rem' color={graphColor} />}
          onClick={() => {}}
          extraIcon={<Icon size='medium' name='ChevronRight' alpha={0.7} />}
        />
      </SubMenuWrapper>
    </Tooltip>
  );
};

export default ColorPickerItem;
